import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-text-center"
}

import Text from "@/core/components/ui/general/Text.vue";


const __default__ = {
  name: "EmptyState",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ["label", "hasCustomContent", "iconComponent"],
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hasCustomContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.iconComponent))),
          _createVNode(Text, {
            class: "tw-max-w-[297px]",
            textColor: "rgba(12, 15, 74, 0.5)",
            variant: "h5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.label), 1)
            ]),
            _: 1
          }),
          _renderSlot(_ctx.$slots, "action")
        ]))
      : _renderSlot(_ctx.$slots, "custom-content", { key: 1 })
  ]))
}
}

})